import { tokens } from "../tokens";

export const id = {
  [tokens.common.languageChanged]: "Bahasa diubah",
  [tokens.nav.academy]: "Akademi",
  [tokens.nav.account]: "Akun",
  [tokens.nav.analytics]: "Analitik",
  [tokens.nav.auth]: "Autentikasi",
  [tokens.nav.blog]: "Blog",
  [tokens.nav.browse]: "Jelajahi",
  [tokens.nav.calendar]: "Kalender",
  [tokens.nav.changelog]: "Log Perubahan",
  [tokens.nav.chat]: "Obrolan",
  [tokens.nav.checkout]: "Pembayaran",
  [tokens.nav.concepts]: "Konsep",
  [tokens.nav.contact]: "Kontak",
  [tokens.nav.course]: "Kursus",
  [tokens.nav.create]: "Buat",
  [tokens.nav.crypto]: "Kripto",
  [tokens.nav.customers]: "Pelanggan",
  [tokens.nav.dashboard]: "Dasbor",
  [tokens.nav.details]: "Detail",
  [tokens.nav.documentation]: "Dokumentasi",
  [tokens.nav.ecommerce]: "E-Commerce",
  [tokens.nav.edit]: "Edit",
  [tokens.nav.error]: "Kesalahan",
  [tokens.nav.feed]: "Feed",
  [tokens.nav.fileManager]: "Manajer Berkas",
  [tokens.nav.finance]: "Keuangan",
  [tokens.nav.fleet]: "Armada",
  [tokens.nav.forgotPassword]: "Lupa Password",
  [tokens.nav.invoiceList]: "Faktur",
  [tokens.nav.jobList]: "Daftar Pekerjaan",
  [tokens.nav.kanban]: "Kanban",
  [tokens.nav.list]: "Daftar",
  [tokens.nav.login]: "Masuk",
  [tokens.nav.logistics]: "Logistik",
  [tokens.nav.mail]: "Surat",
  [tokens.nav.management]: "Manajemen",
  [tokens.nav.orderList]: "Pesanan",
  [tokens.nav.overview]: "Ikhtisar",
  [tokens.nav.pages]: "Halaman",
  [tokens.nav.postCreate]: "Buat Pos",
  [tokens.nav.postDetails]: "Detail Pos",
  [tokens.nav.postList]: "Daftar Pos",
  [tokens.nav.pricing]: "Harga",
  [tokens.nav.productList]: "Produk",
  [tokens.nav.profile]: "Profil",
  [tokens.nav.register]: "Daftar",
  [tokens.nav.roadmap]: "Peta Jalan",
  [tokens.nav.resetPassword]: "Atur Ulang Password",
  [tokens.nav.socialMedia]: "Media Sosial",
  [tokens.nav.verifyCode]: "Verifikasi Kode",
  [tokens.nav.catalog]: "Katalog",
};
